<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaOras')}} </h4>
        </div>
        <form class="add-user-form" id="add-level2">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group">
                        <div class="selections-option" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('tableHeader.judet')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_county" :options="counties" label="name"></v-select>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons col-md-12">
                    <button @click.prevent='addCity()' :disabled="this.$store.state.loading">
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CitiesService from '../../api-services/cities.service.js'
import CountiesService from '../../api-services/counties.service.js'

export default {
  name: 'addcity',
  data () {
    return {
      cities: null,
      counties: null,
      select_county: null,
      selected_label: null,
      input_fields: {
        column_2: [
          {
            inputName: 'name',
            labelName: this.$t('tableHeader.oras'),
            inputValue: (this.cities) ? this.cities.name : null,
            icon: 'fas fa-city'
          }
        ]
      }
    }
  },
  methods: {
    addCity () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('add-level2'))
      if (this.select_county) {
        formData.append('county', this.select_county.id)
      }
      CitiesService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.orasAdaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push({ name: 'cities' })
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    getCounties () {
      CountiesService.getAll({ per_page: -1 }).then((response) => {
        this.counties = response.data.data
        this.$store.dispatch('hideLoading')
      })
    }
  },
  computed: {},
  created () {
    this.getCounties()
    this.$store.dispatch('hideLoading')
  }
}
</script>
